/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Types_Bug_ReportInputs */

const es_feedback_types_bug_report = /** @type {(inputs: Feedback_Types_Bug_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reporte de Bug`)
};

const en_feedback_types_bug_report = /** @type {(inputs: Feedback_Types_Bug_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bug Report`)
};

/**
* | output |
* | --- |
* | "Bug Report" |
*
* @param {Feedback_Types_Bug_ReportInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_types_bug_report = /** @type {((inputs?: Feedback_Types_Bug_ReportInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Types_Bug_ReportInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_types_bug_report(inputs)
	return en_feedback_types_bug_report(inputs)
});
export { feedback_types_bug_report as "feedback.types.bug_report" }